import { useAsync } from 'react-use-v13';
import apiFetch from '@scale/frontend-lib/api-fetch';
import { SpeedAuditBatchJson } from '@scale/shared/types/speedAudit';

const useAuditBatch = (auditBatchId: string | undefined) => {
  return useAsync(async () => {
    if (!auditBatchId) return null; // This allows us to use the hook conditionally
    const { auditBatch, attemptsWithAttempters, projectId, projectInstrItems, attemptIds } =
      await apiFetch<SpeedAuditBatchJson>(
        null,
        `corp-api/attemptAudit/auditBatches/${auditBatchId}`,
        {
          method: 'GET',
        },
      );
    return {
      attemptAudits: auditBatch.attemptAudits,
      attemptsWithAttempters,
      projectInstrItems,
      projectId,
      attemptIds,
      auditBatch,
    };
  });
};

export default useAuditBatch;
